// filepath: /Users/ducnguyen/working/doctor-dashboard-v2/source/scripts/utils/analytics.js
export const initGA = trackingID => {
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(...args);
  }
  gtag('js', new Date());
  gtag('config', trackingID);
  window.gtag = gtag;
};

export const logPageView = () => {
  window.gtag('event', 'page_view', {
    page_path: window.location.pathname,
  });
};

export const logEvent = (eventName, eventParams) => {
  window.gtag('event', eventName, eventParams);
};

export const logException = (description, fatal = false) => {
  window.gtag('event', 'exception', {
    description,
    fatal,
  });
};
